import axios from "axios";
import apiPath from "@/plugins/api";
export const state = () => ({
  state: {
    stateGetComponentType: null,
    stateGetActionClick: null,
    stateGetEventTypeList: null,
    stateCreateWebChannelSetting: null,
    stateUpdateWebChannelSetting: null,
    stateGetWebChannelSettingDetail: null,
    stateUpdateWebChannelSettingDetail: null,
    stateGetWebChannelComponentList: null,
    stateGetWebChannelComponentDetail: null,
    stateCreateWebChannelComponent: null,
    stateUpdateWebChannelComponent: null,
  },
});

export const mutations = {
  setGetComponentType: async function (state, val) {
    state.stateGetComponentType = val;
  },
  setGetActionClick: async function (state, val) {
    state.stateGetActionClick = val;
  },
  setGetEventTypeList: async function (state, val) {
    state.stateGetEventTypeList = val;
  },
  setCreateWebChannelSetting: async function (state, val) {
    state.stateCreateWebChannelSetting = val;
  },
  setUpdateWebChannelSetting: async function (state, val) {
    state.stateUpdateWebChannelSetting = val;
  },
  setGetWebChannelSettingDetail: async function (state, val) {
    state.stateGetWebChannelSettingDetail = val;
  },
  setUpdateWebChannelSettingDetail: async function (state, val) {
    state.stateUpdateWebChannelSettingDetail = val;
  },
  setGetWebChannelComponentList: async function (state, val) {
    state.stateGetWebChannelComponentList = val;
  },
  setGetWebChannelComponentDetail: async function (state, val) {
    state.stateGetWebChannelComponentDetail = val;
  },
  setCreateWebChannelComponent: async function (state, val) {
    state.stateCreateWebChannelComponent = val;
  },
  setUpdateWebChannelComponent: async function (state, val) {
    state.stateUpdateWebChannelComponent = val;
  },
};

export const actions = {
  getComponentType: async ({ commit }) => {
    await axios.get(`${apiPath}/WebAutomation/DisplayComponentType`).then(
      async (data) => {
        commit("setGetComponentType", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getActionClick: async ({ commit }) => {
    await axios.get(`${apiPath}/WebAutomation/DisplayActionType`).then(
      async (data) => {
        commit("setGetActionClick", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getEventTypeList: async ({ commit }) => {
    await axios.get(`${apiPath}/WebAutomation/EventType`).then(
      async (data) => {
        commit("setGetEventTypeList", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  createWebChannelSetting: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/WebAutomation/Configuration`, payload).then(
      async (data) => {
        commit("setCreateWebChannelSetting", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  updateWebChannelSetting: async ({ commit }, payload) => {
    await axios.put(`${apiPath}/WebAutomation/Configuration`, payload).then(
      async (data) => {
        commit("setUpdateWebChannelSetting", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getWebChannelSettingDetail: async ({ commit }, payload) => {
    await axios.get(`${apiPath}/WebAutomation/Configuration/${payload}`).then(
      async (data) => {
        commit("setGetWebChannelSettingDetail", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  updateWebChannelSettingDetail: async ({ commit }, payload) => {
    await axios.put(`${apiPath}/WebAutomation/SettingDetail`, payload).then(
      async (data) => {
        commit("setUpdateWebChannelSettingDetail", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getWebChannelComponentList: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/WebAutomation/SearchDisplayComponent`, payload).then(
      async (data) => {
        commit("setGetWebChannelComponentList", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getWebChannelComponentDetail: async ({ commit }, payload) => {
    await axios.get(`${apiPath}/WebAutomation/displayComponent/${payload}`).then(
      async (data) => {
        commit("setGetWebChannelComponentDetail", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  createWebChannelComponent: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/WebAutomation/displayComponent`, payload).then(
      async (data) => {
        commit("setCreateWebChannelComponent", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  updateWebChannelComponent: async ({ commit }, payload) => {
    await axios.put(`${apiPath}/WebAutomation/displayComponent`, payload).then(
      async (data) => {
        commit("setUpdateWebChannelComponent", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
};
export const getters = {};

export default {
  state,
  actions,
  mutations,
  getters,
};
